import Api from './api'

const END_POINT = 'waviot/';

export default {
    namespaced: true,
    get_recipients() {
        return Api.get(`${END_POINT}recipients`)
    },
    get_recipient(id) {
        return Api.get(`${END_POINT}recipients/${id}`)
    },
    add(payload) {
        return Api.post(`${END_POINT}recipients`, payload)
    },
    update(payload) {
        return Api.put(`${END_POINT}recipients`, payload)
    },
    delete(id) {
        return Api.delete(`${END_POINT}recipients/${id}`)
    },
    send(to, street_id) {
        return Api.post(`${END_POINT}send/${to}/${street_id}`)
    },
    get_tree(id) {
        return Api.get(`${END_POINT}get_streets/${id}`)
    },
    get_elements() {
        return Api.get(`${END_POINT}get_elements`)
    },
    get_value(id) {
        return Api.get(`${END_POINT}get_value/${id}`)
    },
    get_second_level() {
        return Api.get(`${END_POINT}get_second_level`)
    }
};
